// Agent websites embed the report in an iframe. The report cannot resize that iframe itself, so it tells
// the parent page how tall its content is and the embed snippet on the agent's site sets the iframe height.
// Listener for the agent's site:
//   window.addEventListener("message", (e) => {
//       if (e.data && e.data.type === "oc-report-height") iframe.style.height = e.data.height + "px";
//   });
export const EMBED_HEIGHT_MESSAGE = "oc-report-height";
export const EMBED_HEIGHT_REQUEST = "oc-report-height-request";

export function startEmbedHeightReporting(root: HTMLElement) {
	if (window.parent === window) return;

	let lastHeight = 0;
	let frame = 0;

	// Measure where the content ends, not the document: inside a tall iframe the document is at least as
	// tall as the iframe, so reporting it would never let the iframe shrink. An empty marker right after
	// the app sits exactly at that point, after the layouts' negative margins against the body padding.
	const end = document.createElement("div");
	end.setAttribute("aria-hidden", "true");
	end.style.cssText = "display:block;height:0;margin:0;padding:0;border:0;clear:both";
	root.after(end);

	const send = () => {
		frame = 0;
		const height = Math.ceil(
			end.getBoundingClientRect().top +
				window.scrollY +
				parseFloat(window.getComputedStyle(document.body).paddingBottom || "0")
		);
		if (height <= 0 || height === lastHeight) return;
		lastHeight = height;
		window.parent.postMessage({ type: EMBED_HEIGHT_MESSAGE, height }, "*");
	};
	const schedule = () => {
		if (!frame) frame = window.requestAnimationFrame(send);
	};

	if (typeof ResizeObserver !== "undefined") {
		new ResizeObserver(schedule).observe(root);
	}
	window.addEventListener("resize", schedule);
	// Lets a parent page that attached its listener late ask for the current height again.
	window.addEventListener("message", (e) => {
		if (e.source !== window.parent || e.data?.type !== EMBED_HEIGHT_REQUEST) return;
		lastHeight = 0;
		schedule();
	});
	window.addEventListener("load", schedule);
	schedule();
}
